export const COUNTRY_SELECTION = {
  '38': { value: 'Canada', name: 'Canada', id: '38', code: 'CA' },
  '230': {
    value: 'United States',
    name: 'United States',
    id: '230',
    code: 'US',
  },
  '76': {
    value: 'Great Britain',
    name: 'United Kingdom',
    id: '76',
    code: 'GB',
  },
};

export const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return phoneNumber;
  const cleaned = phoneNumber.replace(/\D/g, '');

  //Check if the phone is USA
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    //Remove the matched extension code
    const intlCode = match[1] ? '+1 ' : '';
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }
  // return unfomatted phone number
  return phoneNumber;
};
